<template>
  <section class="my-information__content">
    <header class="content__header">
      <h2>{{ $t('userInfo.lnb.myInformation') }}</h2>
    </header>
    <edit-information
      v-if="!applyWithdraw"
      @applyWithdraw="applyWithdraw = true" />
    <deactivate-info
      v-else
      @closeWithdraw="applyWithdraw = false"/>
  </section>
</template>

<script>
import EditInformation from '@/components/user-info/my-information/EditInformation'
import DeactivateInfo from '@/components/user-info/my-information/DeactivateInfo'

export default {
  components: {
    EditInformation,
    DeactivateInfo
  },
  data () {
    return {
      applyWithdraw: false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.my-information__content {
  position: relative;
  float: left;
  width: calc(100% - 211px);
  margin-top: 40px;
  box-sizing: border-box;

  .content__header {
    font-size: 26px;
    font-weight: 500;
    color: #444444;
    margin-left: 30px;
    margin-right: 30px;
    padding-bottom: 22px;
    border-bottom: 1px solid #d7d7d7;

    h2 {
      padding-left: 10px;
    }
  }
}
</style>
